import {z as zod} from "zod";

export type DuluxLocationPagesWorkspaceCapabilityConfiguration = Record<string, never>;

export const duluxLocationPagesWorkspaceCapabilityConfigurationValidator: zod.ZodType<DuluxLocationPagesWorkspaceCapabilityConfiguration> = zod.strictObject(
    {},
);
